require('./').install();



//////////////////
// WEBPACK FOOTER
// ./~/source-map-support/register.js
// module id = 258
// module chunks = 0